export function isSimulfestSession(): boolean {
  const url = new URL(window.location.href);
  return url.searchParams.get("simulfest") === "1";
}
